/**
 * @param {number} numberOfPayments
 * @param {Array<SPPIRate>} SPPIRates
 */
export function getSPPIRate(numberOfPayments, SPPIRates) {
    var resultRate = SPPIRates.filter(function (rate) {
        if (rate.term_max === null) {
            return rate.term_min <= numberOfPayments;
        }
        return rate.term_min <= numberOfPayments && numberOfPayments <= rate.term_max;
    });
    if (resultRate.length !== 1) {
        throw 'SPPI rate not found';
    }
    return resultRate[0].rate;
}
/**
 * @param {number} numberOfPayments
 * @param {LoanInput} input
 * @param {Array<Rate>} rates
 * @return number
 */
export function getRate(numberOfPayments, input, rates) {
    var resultRates;
    resultRates = getRatesByCategory(input.category, rates);
    resultRates = getRatesByInsurance(input.insurance, resultRates);
    resultRates = getRatesByAmount(input.amount, resultRates);
    resultRates = getRatesByTerm(numberOfPayments, resultRates);
    if (resultRates.length !== 1) {
        throw 'Rate not found';
    }
    return resultRates[0].rate / 100;
}
/**
 * @param {string} category
 * @param {Array<Rate>} rates
 * @return Array<Rate>
 */
export function getRatesByCategory(category, rates) {
    return rates.filter(function (rate) { return category === rate.category; });
}
/**
 * @param {boolean} insurance
 * @param {Array<Rate>} rates
 * @return Array<Rate>
 */
export function getRatesByInsurance(insurance, rates) {
    return rates.filter(function (rate) { return insurance === rate.insurance; });
}
/**
 * @param {number} amount
 * @param {Array<Rate>} rates
 * @return Array<Rate>
 */
export function getRatesByAmount(amount, rates) {
    return rates.filter(function (rate) { return rate.sum_min <= amount && amount <= rate.sum_max; });
}
/**
 * @param {number} term
 * @param {Array<Rate>} rates
 * @return Array<Rate>
 */
export function getRatesByTerm(term, rates) {
    return rates.filter(function (rate) { return rate.rate_start <= term && term <= rate.rate_finish; });
}
